import MRPRoutes from "./mrp";
import CropTrackerRoutes from "./crop-tracker";

export default [
    ...MRPRoutes,
    ...CropTrackerRoutes
];
